export enum EduSpecificsType {
  INTERNSHIP = 'I',
  NETWORK = 'N',
  SIMULATION = 'S',
  REMOTE_DOT_AND_EO = 'R',
  OUTBOUND = 'O'
}
